import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const TransactionBridgeComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      className="nostra__icon nostra__icon__transactionBridge"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7" cy="7" r="6.5" fill="#DAE1F5" stroke="white" />
      <g clip-path="url(#clip0_3480_5571)">
        <line x1="3.5" y1="8.5" x2="10.5" y2="8.5" stroke={colorVar} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5 4C5 4 5 6 7 6C9 6 9 4 9 4" stroke={colorVar} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3.5 5.84615C5 5.33028 5 4 5 4L5 10" stroke={colorVar} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.5 5.84615C9 5.33028 9 4 9 4L9 10" stroke={colorVar} strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_3480_5571">
          <rect width="8" height="8" fill="white" transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TransactionBridge = withIcon(TransactionBridgeComponent);
